import { BaseApi } from './base.api.js';

export class QueueObservabilityApi extends BaseApi {
    constructor(client) {
        super(client, '/queue-observability');
    }

    async getOverview() {
        const response = await this.client.get(`${this.basePath}/overview`);
        return response.data;
    }

    async retryFailed(body) {
        const response = await this.client.post(`${this.basePath}/retry-failed`, body);
        return response.data;
    }

    async drain(body) {
        const response = await this.client.post(`${this.basePath}/drain`, body);
        return response.data;
    }

    async removeJob(body) {
        const response = await this.client.post(`${this.basePath}/remove-job`, body);
        return response.data;
    }

    async enqueueHeavyTask(body) {
        const response = await this.client.post(`${this.basePath}/heavy-task`, body);
        return response.data;
    }

    async getTrace(correlationId) {
        const response = await this.client.get(`${this.basePath}/trace/${encodeURIComponent(correlationId)}`);
        return response.data;
    }
}
